import { render, staticRenderFns } from "./studioDashboardEmployeeTargetHoursDialog.vue?vue&type=template&id=a5d5bee0&scoped=true"
import script from "./studioDashboardEmployeeTargetHoursDialog.vue?vue&type=script&lang=js"
export * from "./studioDashboardEmployeeTargetHoursDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d5bee0",
  null
  
)

export default component.exports